import React from "react";
import {
  Card,
  CardContent,
  Avatar,
  Typography,
  Box,
  Grid,
} from "@mui/material";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const SuccessRate = ({ successDetails, srDuration, isAgent, isPayout }) => {
  const data = successDetails || [];
  const getFilteredData = () => {
    const srType = isPayout ? "payout_sr" : "payin_sr"; // Determine whether it's payout or payin
    const category = isAgent ? "agent_sr" : "merchant_sr"; // Determine agent or merchant list
    const dataList = data?.[srType]?.[category] || []; // Safely access data

    if (!Array.isArray(dataList)) {
      return []; // Return an empty array if dataList is invalid
    }

    return dataList.map((performer) => ({
      ...performer,
      percentage: performer.success_rate || 0, // Assign success_rate as percentage
    }));
  };

  const filteredData = [...getFilteredData()];
  return (
    <Box sx={{ maxWidth: 800, mx: "auto", p: 0 }}>
      <Card sx={{ boxShadow: 0, borderRadius: 2, paddingBottom: 0 }}>
        <CardContent sx={{ padding: 0, margin: 0 , paddingBottom: 0}}>
          <Grid container spacing={1} sx={{ padding: 0, margin: 0 , paddingBottom: 0}}>
            {filteredData.length > 0 ? (
              filteredData?.map((performer, index) => (
                <Grid item xs={12} key={index} sx={{ p: 0 }}>
                  <Card
                    sx={{
                      p: 0,
                      borderRadius: 2,
                      boxShadow: 1,
                      transition: "all 0.3s ease",
                      "&:hover": { boxShadow: 4 },
                    }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-between"
                      style={{ padding: "6px 12px" }}
                    >
                      {/* Avatar and Name */}
                      <div className="d-flex align-items-center">
                        <Avatar
                          alt={performer.name}
                          sx={{
                            width: 28,
                            height: 28,
                            border: 2,
                            borderColor: "common.white",
                            boxShadow: 2,
                            fontSize: "12px",
                            background: "#495a69",
                          }}
                        >
                          {performer?.name?.charAt(0)}
                        </Avatar>
                        <Typography
                          variant="h6"
                          sx={{
                            ml: 1,
                            fontSize: "12.5px",
                            color: "#495a69",
                          }}
                        >
                          {performer.name}{" "}
                          {performer.code && <span>({performer.code})</span>}
                        </Typography>
                      </div>

                      {/* Circular Progress Bar */}
                      <div style={{ width: "50px", height: "50px" }}>
                        <CircularProgressbar
                          value={
                            performer.percentage
                              ? performer.percentage.toFixed(2)
                              : performer.percentage
                          }
                          text={`${
                            performer.percentage
                              ? performer.percentage.toFixed(2)
                              : performer.percentage
                          }%`}
                          styles={buildStyles({
                            textSize: "25px",
                            pathColor: "#7bb2b7f5",
                            textColor: "black",
                            backgroundColor: "#7bb2b7f5",
                          })}
                        />
                      </div>
                    </div>
                  </Card>
                </Grid>
              ))
            ) : (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  textAlign: "center",
                  width: "100%",
                  p: 2,
                  height: "200px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                No data available
              </Typography>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SuccessRate;
